angular.module('zc.projects')

.directive 'zcItemPriceEditor', (ProjectItemPrice, Meta, BaseProjectCrudEditor) ->

  class ItemPriceEditor extends BaseProjectCrudEditor
    link: (scope, element, attrs) ->
      # only this specific functionality

  editor = new ItemPriceEditor(
    ProjectItemPrice
    Meta
    '/templates/projects.settings/initialization/item_price_editor.html'
  )

  return editor.createDirective()



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.settings/initialization/item_price_editor.directive.coffee